import React, {Fragment} from 'react';

const CategoryItem = ({ links = []  }) => {

    return (
      <div className="category-children">
        {links.map(
          (link) =>
            link.isSelected && (
              <Fragment>
                {link.links.map(
                  (link) =>
                    link.isSelected && (
                      <Fragment>
                        {link.links.map((link) => (
                          <a href={link.url} className="category-item-children">
                            {link.name}
                          </a>
                        ))}
                      </Fragment>
                    )
                )}
              </Fragment>
            )
        )}
      </div>
    );
};

export default CategoryItem;
